import { render, staticRenderFns } from "./WardNotification.vue?vue&type=template&id=072c4730&scoped=true&"
import script from "./WardNotification.vue?vue&type=script&lang=js&"
export * from "./WardNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072c4730",
  null
  
)

export default component.exports